import React from 'react'
import type { FC } from 'react'
import type { IconButtonProps } from '@/tools/ui'
import { IconButton } from '@/tools/ui'
import { NavigationMenuDrawer } from '@/tools/ui/components/navigation-menu/partials/navigation-menu-drawer/NavigationMenuDrawer'

export type NavigationMenuContentProps = {
  isOpen: boolean
  onClose?: () => void
}
export type NavigationMenuContentType = React.ComponentType<NavigationMenuContentProps>

type Props = IconButtonProps & {
  NavigationMenuContent: NavigationMenuContentType
}

export const NavigationMenu: FC<Props> = ({ NavigationMenuContent, ...buttonProps }) => {
  const [isNavMenuOpen, setIsNavMenuOpen] = React.useState(false)

  const handleToggleNavMenu = () => {
    setIsNavMenuOpen(!isNavMenuOpen)
  }

  return (
    <>
      <IconButton {...buttonProps} onClick={handleToggleNavMenu} />
      <NavigationMenuDrawer isOpen={isNavMenuOpen} onClose={handleToggleNavMenu}>
        <NavigationMenuContent isOpen={isNavMenuOpen} onClose={handleToggleNavMenu} />
      </NavigationMenuDrawer>
    </>
  )
}
